<template>
    <div class="animated fadeIn master-page">
        <div class="row">
            <!-- Left Card: Form Control Panel -->
            <div class="col-12 col-lg-5 mb-4 mb-lg-0">
                <div class="laporan-form-card h-100 d-flex flex-column justify-content-between">
                    <div>
                        <!-- Title -->
                        <h4 class="form-card-title mb-4">Laporan Pelunasan</h4>

                        <b-form @submit.prevent="openModalConfirm" id="formLaporanPelunasan">
                            <!-- Cabang -->
                            <b-form-group class="mb-3">
                                <div class="d-flex align-items-center justify-content-between mb-1">
                                    <label class="form-input-label mb-0">Cabang</label>
                                    <b-form-checkbox 
                                        v-if="fullAccess == 1"
                                        v-model="input.allCabang"
                                        name="allCabang"
                                        class="custom-checkbox-small"
                                    >
                                        <span class="small-check-label">Semua Cabang</span>
                                    </b-form-checkbox>
                                </div>
                                <multiselect
                                    name="cabang"
                                    :disabled="input.allCabang"
                                    v-model="input.cabang" 
                                    :options="cabangOption" 
                                    :internal-search="true"
                                    :allow-empty="true"
                                    deselect-label=""
                                    select-label=""
                                    label="name"
                                    track-by="name"
                                    placeholder="-- Pilih Cabang --"
                                    class="custom-multiselect"
                                />
                            </b-form-group>

                            <!-- Tipe Pinjaman -->
                            <b-form-group label="Tipe Pinjaman" label-class="form-input-label" class="mb-3">
                                <b-form-select 
                                    class="form-control-custom" 
                                    v-model="input.tipePinjaman" 
                                    name="tipePinjaman" 
                                    :options="tipeOption" 
                                    value-field="id" 
                                    text-field="name"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Pilih Tipe Pinjaman --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>

                            <!-- Metode Pembayaran -->
                            <b-form-group label="Metode Pembayaran" label-class="form-input-label" class="mb-3">
                                <b-form-select 
                                    class="form-control-custom" 
                                    v-model="input.metodePembayaran" 
                                    name="metodePembayaran" 
                                    :options="optionPembayaran" 
                                    value-field="id" 
                                    text-field="name"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Pilih Metode --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>

                            <!-- Periode Section -->
                            <div class="periode-section mb-4">
                                <!-- Harian -->
                                <div class="periode-row d-flex align-items-center mb-3">
                                    <div class="radio-label-wrapper">
                                        <b-form-radio v-model="dateType" value="harian" class="custom-radio">
                                            <span class="radio-text">Harian</span>
                                        </b-form-radio>
                                    </div>
                                    <div class="flex-grow-1 pl-2">
                                        <b-form-input 
                                            v-model="input.tanggal" 
                                            name="tanggal" 
                                            type="date" 
                                            :min="minDate" 
                                            :max="maxDate"
                                            class="form-control-custom"
                                            :class="{ 'active-input': dateType === 'harian' }"
                                            :disabled="dateType !== 'harian'"
                                        ></b-form-input>
                                    </div>
                                </div>

                                <!-- Bulanan -->
                                <div class="periode-row d-flex align-items-center">
                                    <div class="radio-label-wrapper">
                                        <b-form-radio v-model="dateType" value="bulanan" class="custom-radio">
                                            <span class="radio-text">Bulanan</span>
                                        </b-form-radio>
                                    </div>
                                    <div class="flex-grow-1 pl-2">
                                        <!-- Non Full Access -->
                                        <b-form-select 
                                            v-if="fullAccess != 1"
                                            v-model="input.bulan" 
                                            id="inputBulan" 
                                            name="inputBulan" 
                                            :options="optionBulan" 
                                            value-field="id" 
                                            text-field="name"
                                            class="form-control-custom w-100"
                                            :class="{ 'active-input': dateType === 'bulanan' }"
                                            :disabled="dateType !== 'bulanan'"
                                        >
                                            <template v-slot:first>
                                                <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                            </template>
                                        </b-form-select>

                                        <!-- Full Access -->
                                        <div v-else class="d-flex gap-2">
                                            <b-form-select 
                                                class="form-control-custom mr-2" 
                                                v-model="input.bulan" 
                                                id="inputBulan" 
                                                name="inputBulan" 
                                                :options="bulan" 
                                                value-field="id" 
                                                text-field="name"
                                                :class="{ 'active-input': dateType === 'bulanan' }"
                                                :disabled="dateType !== 'bulanan'"
                                            >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <b-form-select 
                                                class="form-control-custom" 
                                                v-model="input.tahun" 
                                                id="inputTahun" 
                                                name="inputTahun" 
                                                :options="optionTahun"
                                                :class="{ 'active-input': dateType === 'bulanan' }"
                                                :disabled="dateType !== 'bulanan'"
                                            >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>Tahun</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Cetak Button -->
                            <button 
                                type="submit" 
                                name="submitLaporan" 
                                class="btn btn-cetak-full w-100 d-flex align-items-center justify-content-center"
                                :disabled="isSubmitting"
                            >
                                <b-spinner small v-if="isSubmitting" class="mr-2"></b-spinner>
                                <i v-else class="fa fa-file-excel-o mr-2"></i>
                                <span>{{ isSubmitting ? 'Memproses Excel...' : 'Cetak Laporan Pelunasan' }}</span>
                            </button>
                        </b-form>
                    </div>

                    <!-- Footnote -->
                    <div class="form-footnote mt-4">
                        <p class="mb-0 text-muted">
                            <i class="fa fa-info-circle mr-1"></i>
                            Laporan pelunasan diekspor langsung ke format <strong>Microsoft Excel (.xlsx)</strong>.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Right Card: Status & Download Panel -->
            <div class="col-12 col-lg-7">
                <div class="laporan-status-card h-100 d-flex flex-column">
                    <!-- Header -->
                    <div class="status-header mb-3 pb-3">
                        <h4 class="status-title mb-0">Informasi Hasil Cetak</h4>
                    </div>

                    <!-- Container Area -->
                    <div class="status-body flex-grow-1 d-flex align-items-center justify-content-center">
                        <!-- State 1: Loading -->
                        <div v-if="isSubmitting || isLoading" class="state-box text-center py-5">
                            <b-spinner class="align-middle mb-3 text-success" style="width: 3.5rem; height: 3.5rem;"></b-spinner>
                            <h5 class="state-title">Memproses Laporan Excel...</h5>
                            <p class="state-subtitle text-muted mb-0">
                                Sistem sedang menyusun data pelunasan dan mengekspor ke format Excel (.xlsx). Mohon tunggu beberapa saat.
                            </p>
                        </div>

                        <!-- State 2: Success / Ready to Download -->
                        <div v-else-if="filePathDownload" class=" w-100 p-3">
                            <div class="d-flex align-items-center mb-4">
                                <div class="excel-icon-circle mr-3">
                                    <i class="fa fa-file-excel-o"></i>
                                </div>
                                <div>
                                    <h5 class="success-title mb-1">Laporan Pelunasan Siap Diunduh!</h5>
                                    <p class="success-subtitle text-muted mb-0">
                                        Data pelunasan berhasil diekspor ke file Microsoft Excel.
                                    </p>
                                </div>
                            </div>

                            <!-- Detail Laporan Table -->
                            <div class="detail-info-table mb-4">
                                <div class="info-row d-flex justify-content-between py-2 border-bottom">
                                    <span class="info-label text-muted">Format File</span>
                                    <span class="info-value font-weight-bold text-success">
                                        <i class="fa fa-file-excel-o mr-1"></i> Microsoft Excel (.xlsx)
                                    </span>
                                </div>
                                <div class="info-row d-flex justify-content-between py-2 border-bottom">
                                    <span class="info-label text-muted">Cabang</span>
                                    <span class="info-value font-weight-bold">
                                        {{ input.allCabang ? 'Semua Cabang' : (input.cabang ? input.cabang.name : '-') }}
                                    </span>
                                </div>
                                <div class="info-row d-flex justify-content-between py-2 border-bottom">
                                    <span class="info-label text-muted">Tipe Pinjaman</span>
                                    <span class="info-value font-weight-bold">{{ getTipePinjamanName() }}</span>
                                </div>
                                <div class="info-row d-flex justify-content-between py-2 border-bottom">
                                    <span class="info-label text-muted">Metode Pembayaran</span>
                                    <span class="info-value font-weight-bold">
                                        {{ input.metodePembayaran === true ? 'Tunai' : (input.metodePembayaran === false ? 'Non-Tunai' : '-') }}
                                    </span>
                                </div>
                                <div class="info-row d-flex justify-content-between py-2 border-bottom">
                                    <span class="info-label text-muted">Periode</span>
                                    <span class="info-value font-weight-bold">{{ getPeriodeText() }}</span>
                                </div>
                                <div class="info-row d-flex justify-content-between py-2">
                                    <span class="info-label text-muted">Nama File</span>
                                    <span class="info-value font-weight-600 text-break text-dark">{{ getFileName() }}</span>
                                </div>
                            </div>

                            <!-- Big Download Button -->
                            <div class="text-center pt-2">
                                <a 
                                    :href="urlLaporan" 
                                    download 
                                    class="btn btn-download-excel d-inline-flex align-items-center justify-content-center w-100"
                                >
                                    <i class="fa fa-download mr-2 fa-lg"></i>
                                    <span>Download File Excel (.xlsx)</span>
                                </a>
                            </div>
                        </div>

                        <!-- State 3: Empty Placeholder -->
                        <div v-else class="state-box empty-state text-center py-5">
                            <div class="empty-icon-circle mb-3">
                                <i class="fa fa-file-excel-o"></i>
                            </div>
                            <h5 class="state-title">Belum Ada Laporan Dicetak</h5>
                            <p class="state-subtitle text-muted mb-0">
                                Silakan atur filter cabang, tipe pinjaman, metode pembayaran, dan periode di panel sebelah kiri, kemudian klik tombol <strong>Cetak Laporan Pelunasan</strong>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Confirm -->
        <ModalConfirm 
            id="modal-confirm-cetak" 
            title="Konfirmasi Cetak Laporan Pelunasan" 
            :isSubmitting="isSubmitting" 
            desc="Apakah anda yakin untuk mencetak laporan pelunasan ini ke format Excel?" 
            @submit="onSubmit" 
        />
    </div>
</template>

<script>
export default {
    name: 'laporan-pelunasan',
    data(){
        return{
            isSubmitting: false,
            isLoading: false,
            cabang: null,
            fullAccess: null,
            input: {
                allCabang: false,
                cabang: null,
                tipePinjaman: null,
                metodePembayaran: null,
                tanggal: null,
                bulan: null,
                tahun: null,
                startDate: null,
                endDate: null,
            },
            cabangOption: [],
            optionBulan: [],
            optionTahun: [],
            tipeOption: [
                { id: "GE", name: "Gadai Elektronik" },
                { id: "GB", name: "Gadai BPKB" },
                { id: "GK", name: "Gadai Kendaraan" }
            ],
            optionPembayaran: [
                { id: true, name: "Tunai" },
                { id: false, name: "Non-Tunai" }
            ],
            bulan: [
                { id: 1, name: "Januari" },
                { id: 2, name: "Februari" },
                { id: 3, name: "Maret" },
                { id: 4, name: "April" },
                { id: 5, name: "Mei" },
                { id: 6, name: "Juni" },
                { id: 7, name: "Juli" },
                { id: 8, name: "Agustus" },
                { id: 9, name: "September" },
                { id: 10, name: "Oktober" },
                { id: 11, name: "November" },
                { id: 12, name: "Desember" }
            ],
            dateType: "harian",
            urlLaporan: null,
            filePathDownload: "",
            query: "",
            minDate: null,
            maxDate: null
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            let date = new Date().toISOString().slice(0, 10)
            this.input.tanggal = date

            this.$axios.get('laporan/durasi-laporan').then(response => {
                this.fullAccess = response.data.id
                if(response.data.id != 1){
                    this.cabangOption = this.$helper.getAllCabang()
                }else{
                    this.$axios.get("cabang/all-selection").then(response => {
                        this.cabangOption = response.data
                    })
                }

                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();
                if(dd<10) dd='0'+dd;
                if(mm<10) mm='0'+mm;

                today = yyyy+'-'+mm+'-'+dd;
                this.maxDate = today

                if (this.fullAccess != 1){
                    var threeDaysAgo = new Date()
                    threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)
                    var ddd = threeDaysAgo.getDate()
                    var mmm = threeDaysAgo.getMonth()+1
                    var yyy = threeDaysAgo.getFullYear()
                    if(ddd<10) ddd='0'+ddd;
                    if(mmm<10) mmm='0'+mmm;

                    threeDaysAgo = yyy+'-'+mmm+'-'+ddd;
                    this.minDate = threeDaysAgo
                }

                var months = ["Januari", "Februari", "Maret", "April", 
                                "Mei", "Juni", "Juli", "Agustus", 
                                "September", "Oktober", "November", "Desember"]
                
                if (this.fullAccess != 1){
                    var d = new Date()
                    var thisMonth = d.getMonth()
                    var thisYear = d.getFullYear()

                    var lastMonth = d.getMonth() - 1
                    if(lastMonth < 0){
                        lastMonth += 12
                        d.setYear(d.getYear() - 1)
                        var lastYear = d.getFullYear()
                    } else {
                        var lastYear = thisYear
                    }

                    this.optionBulan = [
                        { id: (thisMonth + 1), name: months[thisMonth] + " " + thisYear },
                        { id: (lastMonth + 1), name: months[lastMonth] + " " + lastYear }
                    ]
                } else {
                    var thisYear = new Date().getFullYear()
                    for(var i = 2019; i <= thisYear; i++) {
                        this.optionTahun.push(i)
                    }
                }
            })
        },

        //----------------- Helper Format Data -----------------

        getTipePinjamanName() {
            let item = this.tipeOption.find(t => t.id === this.input.tipePinjaman)
            return item ? item.name : (this.input.tipePinjaman || '-')
        },

        getPeriodeText() {
            if (this.dateType === 'harian') {
                return this.input.tanggal ? this.$helper.changeDateFormat(this.input.tanggal) : '-'
            } else {
                let m = this.bulan.find(b => b.id === this.input.bulan)
                let bulanName = m ? m.name : (this.input.bulan || '-')
                return `${bulanName} ${this.input.tahun || ''}`
            }
        },

        getFileName() {
            if (!this.filePathDownload) return '-'
            let parts = this.filePathDownload.split('/')
            return parts[parts.length - 1]
        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
            this.isSubmitting = true
            this.isLoading = true

            let start = this.input.tanggal
            let end = this.input.tanggal

            if (this.dateType === 'bulanan') {
                let year = this.input.tahun || new Date().getFullYear()
                let month = this.input.bulan || (new Date().getMonth() + 1)
                start = `${year}-${String(month).padStart(2, '0')}-01`
                let lastDay = new Date(year, month, 0).getDate()
                end = `${year}-${String(month).padStart(2, '0')}-${lastDay}`
            }

            let cabangId = (this.input.cabang == null || this.input.allCabang) ? 0 : this.input.cabang.id

            this.query = `?cabangId=${cabangId}&tipePinjaman=${this.input.tipePinjaman}&startDate=${start}&endDate=${end}&allCabang=${this.input.allCabang}`
            if (this.input.metodePembayaran !== null && this.input.metodePembayaran !== undefined) {
                this.query += `&tunai=${this.input.metodePembayaran}`
            }

            this.$axios.get(`laporan/pelunasan${this.query}`).then(response => {
                let filePath = response.data
                if (typeof filePath === 'object' && filePath !== null && filePath.name) {
                    filePath = filePath.name
                }
                let base = this.$baseFilePath.endsWith('/') ? this.$baseFilePath : this.$baseFilePath + '/'
                let path = typeof filePath === 'string' && filePath.startsWith('/') ? filePath.slice(1) : filePath
                this.urlLaporan = base + path
                this.filePathDownload = filePath

                this.$helper.setFlash(`Laporan pelunasan berhasil dibuat!`)
                this.$bvModal.hide("modal-confirm-cetak")
                
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })
            .catch(error => {
                console.log(error)
                if (error.response && error.response.data && error.response.data.reason) {
                    console.log(error.response.data.reason)
                }
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
                this.isLoading = false
            })
        },

        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if(this.input.allCabang == false && this.input.cabang == null){
                this.$helper.toastErr(this, "Mohon isi data cabang terlebih dahulu!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjaman)){
                this.$helper.toastErr(this, "Mohon isi data tipe pinjaman terlebih dahulu!")
            }else if(this.input.metodePembayaran === null || this.input.metodePembayaran === undefined){
                this.$helper.toastErr(this, "Mohon pilih metode pembayaran terlebih dahulu!")
            }else if(this.dateType == 'harian' && !this.$helper.isNotNullAndNotEmpty(this.input.tanggal)){
                this.$helper.toastErr(this, "Mohon lengkapi tanggal untuk cetak laporan!")
            }else if(this.dateType == 'bulanan' && this.input.bulan == null){
                this.$helper.toastErr(this, "Mohon lengkapi bulan untuk cetak laporan!")
            }else if(this.dateType == 'bulanan' && this.fullAccess == 1 && this.input.tahun == null){
                this.$helper.toastErr(this, "Mohon lengkapi tahun untuk cetak laporan!")
            }else{
                this.$bvModal.show("modal-confirm-cetak")
            }            
        }
    },

    created(){
        this.init()
    }
}
</script>

<style lang="scss" scoped>
$deep-pine: #023831;
$deep-pine-hover: #034d43;
$gold-accent: #C69B6B;
$ink-heading: #1B2E28;
$ink-body: #32433D;
$ink-muted: #8C9F98;
$input-border: #D8E0DC;
$card-border: #E8ECE9;

.master-page {
    padding: 0 4px 24px;
}

// Left Card
.laporan-form-card {
    background: #FFFFFF;
    border-radius: 14px;
    box-shadow: 0 2px 12px rgba(2, 56, 49, 0.05);
    border: 1px solid $card-border;
    padding: 24px 26px;
}

.form-card-title {
    font-size: 18px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

::v-deep .form-input-label {
    font-size: 13px;
    font-weight: 500;
    color: $ink-body;
    margin-bottom: 6px;
}

.custom-checkbox-small {
    font-size: 11.5px;
    color: $ink-muted;

    .small-check-label {
        font-size: 11.5px;
        color: #556B64;
        font-weight: 500;
    }
}

.form-control-custom {
    height: 38px;
    border-radius: 8px;
    border: 1px solid $input-border;
    font-size: 13px;
    color: $ink-body;
    padding: 6px 12px;
    background-color: #FFFFFF;
    transition: all 0.2s ease;

    &:focus {
        border-color: $deep-pine;
        box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
        outline: none;
    }

    &.active-input {
        border-color: $deep-pine;
    }

    &:disabled {
        background-color: #F8FAF9;
        opacity: 0.65;
        cursor: not-allowed;
    }
}

// Radio Section
.periode-section {
    .radio-label-wrapper {
        min-width: 85px;
    }

    .radio-text {
        font-size: 13px;
        font-weight: 500;
        color: $ink-body;
    }
}

// Multiselect styling
.custom-multiselect {
    min-height: 38px;

    ::v-deep {
        .multiselect__tags {
            min-height: 38px;
            border-radius: 8px;
            border: 1px solid $input-border;
            padding: 7px 36px 0 12px;
            background: #FFFFFF;
            transition: all 0.2s ease;
        }

        .multiselect__placeholder {
            margin-bottom: 0;
            padding-top: 0;
            color: #8C9F98;
            font-size: 13px;
        }

        .multiselect__single {
            margin-bottom: 0;
            padding-top: 0;
            font-size: 13px;
            color: $ink-body;
            line-height: 22px;
        }

        .multiselect__select {
            height: 36px;
            width: 32px;
            padding: 4px 6px;
        }

        &.multiselect--active .multiselect__tags {
            border-color: $deep-pine;
            box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
        }
    }
}

// Button Cetak
.btn-cetak-full {
    background-color: $deep-pine;
    border: none;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 600;
    height: 42px;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background-color: $deep-pine-hover;
        color: #FFFFFF;
        box-shadow: 0 4px 10px rgba(2, 56, 49, 0.15);
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
}

.form-footnote {
    font-size: 12px;
    color: #8C9F98;
    line-height: 1.45;
}

// Right Card (Status & Download Panel)
.laporan-status-card {
    background: #FFFFFF;
    border-radius: 14px;
    box-shadow: 0 2px 12px rgba(2, 56, 49, 0.05);
    border: 1px solid $card-border;
    padding: 24px 26px;
    min-height: 480px;
}

.status-header {
    border-bottom: 1px solid #EEF2F0;
}

.status-title {
    font-size: 18px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

.status-body {
    background: #F8FAF9;
    border-radius: 12px;
    border: 1px solid #E2E8E5;
    padding: 24px;
}

.state-box {
    max-width: 440px;
}

.state-title {
    font-size: 17px;
    font-weight: 700;
    color: $ink-heading;
    margin-bottom: 8px;
}

.state-subtitle {
    font-size: 13px;
    line-height: 1.5;
}

.empty-icon-circle {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: #EBF3F0;
    color: $deep-pine;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
}

.result-success-box {
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #D8E4DE;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.excel-icon-circle {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    background: #E8F5E9;
    color: #2E7D32;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    flex-shrink: 0;
}

.success-title {
    font-size: 16px;
    font-weight: 700;
    color: #1B2E28;
}

.success-subtitle {
    font-size: 12.5px;
}

.detail-info-table {
    background: #FBFDFB;
    border: 1px solid #E8ECE9;
    border-radius: 8px;
    padding: 8px 16px;
}

.info-label {
    font-size: 12.5px;
}

.info-value {
    font-size: 12.5px;
    color: #1B2E28;
}

.btn-download-excel {
    background-color: #2E7D32;
    border: none;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 600;
    height: 44px;
    border-radius: 8px;
    text-decoration: none;
    transition: all 0.2s ease;

    &:hover {
        background-color: #1B5E20;
        color: #FFFFFF;
        text-decoration: none;
        box-shadow: 0 4px 12px rgba(46, 125, 50, 0.25);
    }
}

// Custom Radio Indicator
::v-deep .custom-radio {
    .custom-control-input:checked ~ .custom-control-label::before {
        background-color: $deep-pine;
        border-color: $deep-pine;
    }
}
</style>
